import { generateClient } from 'aws-amplify/api';
import { GraphQLError } from 'graphql/error';
import { usersV2 } from './API/graphql/queries';
import { createUserV2 } from './API/graphql/mutations';
import {
  CreateUserV2MutationVariables,
  UsersV2Query,
  UsersV2QueryVariables,
} from './API/types';
import { ParsedResponse } from './util';

export type UserV2Summary = NonNullable<
  NonNullable<UsersV2Query['usersV2']>[number]
>;

/**
 * Wrap the generated mutation so UI code can stay on the repo's standard
 * ParsedResponse contract instead of handling Amplify GraphQL response details.
 */
export const createV2 = async (
  variables: CreateUserV2MutationVariables,
): Promise<ParsedResponse<boolean>> => {
  const client = generateClient();

  try {
    const response = await client.graphql({
      query: createUserV2,
      variables,
    });
    if (response.errors) {
      return { data: null, errors: response.errors.map(err => err.message) };
    }

    return { data: response.data.createUserV2 ?? false, errors: null };
  } catch (error) {
    // @ts-ignore
    const errors = error?.errors?.map((item: GraphQLError) => item.message) || [
      'Unable to create beta portal user',
    ];
    return { data: null, errors };
  }
};

/**
 * Read merchant-scoped v2 users so rollout UI can suppress prompts for emails
 * that already have access in the new portal.
 */
export const listV2 = async (
  variables: UsersV2QueryVariables,
): Promise<ParsedResponse<UserV2Summary[]>> => {
  const client = generateClient();

  try {
    const response = await client.graphql({
      query: usersV2,
      variables,
    });
    if (response.errors) {
      return { data: null, errors: response.errors.map(err => err.message) };
    }

    return {
      data:
        (response.data.usersV2?.filter(Boolean) as Array<UserV2Summary>) ?? [],
      errors: null,
    };
  } catch (error) {
    console.log(error);
    // @ts-ignore
    const errors = error?.errors?.map((item: GraphQLError) => item.message) || [
      'Unable to load beta portal users',
    ];
    return { data: null, errors };
  }
};
